import { createSlot } from 'react-slotify';

export const BeforeSlot: ReturnType<typeof createSlot> = createSlot();
export const AfterSlot: ReturnType<typeof createSlot> = createSlot();
